// extracted by css-extract-rspack-plugin
export default {"popoverContent":"GuIJuyEP4B8CrLNr","headerActions":"oXr_AAR5IkjqvzJG"};